export default __webpack_public_path__ + "static/media/i-duplicate.80a250d7.svg";